const ItemTemplate = require('./toast_item.hbs');

function getOrCreateToastContainer() {
	let container = document.querySelector('#toastContainer');
	if (!container) {
		container = document.createElement('div');
		container.id = 'toastContainer';
		container.classList.add('toast-container');
		document.body.appendChild(container);
	}
	return container;
}

function getDefaultOpts(type, opts) {
	if (type === 'error' || type === 'warning') {
		return {
			title: type === 'error' ? 'Fehler' : 'Warnung',
			class: type === 'error' ? 'toast-error' : 'toast-warning',
			...(opts || {})
		}
	} else {
		return {
			title: type === 'success' ? 'Erfolg' : 'Info',
			class: type === 'success' ? 'toast-success' : 'toast-info',
			expires: new Date().getTime() + 5000,
			...(opts || {})
		}
	}
}

let currentToasts = [];
let id = 0;

let interval;

function stopAutoRemoval() {
	if (interval) {
		clearInterval(interval);
		interval = undefined;
	}
}

function startAutoRemoval() {
	if (!interval) {
		interval = setInterval(() => {
			const now = new Date().getTime();
			const container = getOrCreateToastContainer();
			currentToasts = currentToasts.reduce((prev, cur) => {
				if (cur.zweToastOpts && cur.zweToastOpts.expires && cur.zweToastOpts.expires < now) {
					try {
						container.removeChild(cur);
					} catch (e) {
						// node maybe removed already, swallow error
					}
				} else {
					prev.push(cur);
				}
				return prev;
			}, []);

			if (currentToasts.length === 0) {
				stopAutoRemoval();
			}
		}, 1000);
	}
}

const Toast = {

	add: (type, message, opts) => {
		const container = getOrCreateToastContainer();
		const optsToUse = getDefaultOpts(type, opts);

		const item = ItemTemplate({text: message, opts: optsToUse, id});

		const div = document.createElement('div');
		div.innerHTML = item;

		let withHandler = Object.defineProperty(div.firstChild, 'zweCloseToast', {
			value: () => {
				container.removeChild(withHandler);
				currentToasts = currentToasts.concat(withHandler);
			},
			configurable: true, enumerable: true
		});
		withHandler = Object.defineProperty(withHandler, 'zweToastOpts', {
			value: optsToUse,
			configurable: true, enumerable: true
		});

		container.appendChild(withHandler);
		currentToasts = currentToasts.concat(withHandler);
		id++;

		startAutoRemoval();
	},
}

module.exports = Toast;
